import React from "react";
import ModalV2 from "../../../../../shared/components/modalV2";

function DocumentDetailsModal({
  open,
  close,
}: {
  open: boolean;
  close: () => void;
}) {
  return (
    <ModalV2
      isOpen={open}
      isClose={close}
      maxWidth="w-[400px]"
      edges="rounded-xl"
    >
      <div className="px-8 py-10 flex flex-col w-full items-center justify-center gap-y-3">
        <span className="text-2xl font-semibold">Document details</span>
        <div className="w-full grid grid-cols-2">
          <div className="flex flex-col gap-y-1 items-start">
            <span className="text-lg font-normal text-black">
              Document name
            </span>
            <span className="text-lg font-normal text-black">Owner</span>
            <span className="text-lg font-normal text-black">Counsel</span>
            <span className="text-lg font-normal text-black">Date Created</span>
            <span className="text-lg font-normal text-black">Date Filed</span>
          </div>
          <div className="flex flex-col gap-y-1 items-end">
            <span className="text-lg font-normal text-black">
              Writ of Summons
            </span>
            <span className="text-lg font-normal text-black"> Plaintiff</span>
            <span className="text-lg font-normal text-black">
              {" "}
              John Eze Esq
            </span>
            <span className="text-lg font-normal text-black"> 01/10/2024</span>
            <span className="text-lg font-normal text-black">03/10/2024</span>
          </div>
        </div>
        <button
          onClick={close}
          className="bg-[#009444] w-full text-white px-10 py-3 rounded-xl"
        >
          Close
        </button>
      </div>
    </ModalV2>
  );
}

export default DocumentDetailsModal;
